/* Retain the source link purpose if an overlay replaces its name with only a suffix.
 * Preserve the overlay's new-window description and all visible content/layout.
 */
(() => {
  const links = new WeakMap();
  let nextId = 0;
  const normalize = value => value.replace(/\s+/g, ' ').trim().toLowerCase();
  function register(link) {
    if (links.has(link)) return;
    const copy = link.cloneNode(true);
    copy.querySelectorAll('[id^="sro-"]').forEach(node => node.remove());
    const name = link.getAttribute('aria-label') || copy.textContent.trim() || link.querySelector('img')?.alt;
    if (name) links.set(link, { name });
    repair(link);
  }
  function repair(link) {
    const source = links.get(link);
    const ids = link.getAttribute('aria-labelledby')?.split(/\s+/).filter(Boolean);
    if (!source || !ids?.length) return;
    const references = ids.map(id => document.getElementById(id)).filter(Boolean);
    // Leave meaningful author-provided labels alone; only fix the observed SDK suffix.
    if (!references.some(node => node.id.startsWith('sro-')) || normalize(references.map(node => node.textContent).join(' ')).includes(normalize(source.name))) return;
    if (!source.label?.isConnected) {
      source.label = document.createElement('span');
      source.label.id = `AapeLinkPurpose-${++nextId}`;
      source.label.className = 'visually-hidden';
      source.label.textContent = source.name;
      link.appendChild(source.label);
    }
    references.filter(node => node.id.startsWith('sro-')).forEach(node => {
      const text = node.textContent.replace(/^\s*\|\s*/, '');
      if (text !== node.textContent) node.textContent = text;
    });
    link.setAttribute('aria-labelledby', [source.label.id, ...ids.filter(id => id !== source.label.id)].join(' '));
  }
  document.querySelectorAll('a[href]').forEach(register);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes' && record.target.matches('a[href]')) repair(record.target);
      record.addedNodes?.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('a[href]')) register(node);
        node.querySelectorAll('a[href]').forEach(register);
      });
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-labelledby'] });
})();
